export default class OpenAiChatMessageItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.Content = '';
      this.CreatedOnUtc = [];
      this.EntityId = '';
      this.EntityType = '';
      this.ErrorMessage = [];
      this.IsError = false;
      this.MessageType = '';
      this.Role = '';
      this.SessionId = '';
      this.TokenUsage = '';
      this.FullPrice = null;
      this.PromptPrice = null;
      this.OutputPrice = null;
    } else
    {
      this.initialize(item);
    }
  }

  async initialize (item)
  {
    this.Content = item.content;
    this.CreatedOnUtc = item.createdOnUtc;
    this.EntityId = item.entityId;
    this.EntityType = item.entityType;
    this.ErrorMessage = item.errorMessage;
    this.IsError = item.isError;
    this.MessageType = item.messageType;
    this.Role = item.role;
    this.TokenUsage = item.tokenUsage;
    this.FullPrice = item.fullPrice;
    this.PromptPrice = item.promptPrice;
    this.OutputPrice = item.outputPrice;
    this.Model = item.aiModel;
  }
}
